<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title" [innerHTML]="title"></h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="modal.dismiss()"
    >
  </button>
</div>

<div class="modal-body p-3" style="top: 0">
  @if (articleImages.length > 0) {
    <swiper-container
      [navigation]="true"
      [slidesPerView]="1"
      [zoom]="true"
      [keyboard]="{ enabled: true }"
      class="large mb-2 lightbox-carousel image-carousel"
      init="false"
      #swiper
      [thumbs]="{ swiper: thumbsSwiper }"
      thumbs-swiper=".myLightboxSwiper"
      >
      @for (img of articleImages; track img; let i = $index) {
        <swiper-slide>
          <div class="image-wrapper" style="overflow: hidden">
            <div class=" swiper-zoom-container">
              <img [src]="img.big" class="img" loading="lazy" />
            </div>
          </div>
        </swiper-slide>
      }
    </swiper-container>
  }
  @if (articleImages.length > 1) {
    <swiper-container
      (swiper)="thumbsSwiper = $event"
      [spaceBetween]="10"
      [slidesPerView]="4"
      [freeMode]="true"
      [watchSlidesProgress]="true"
      class="myLightboxSwiper d-flex swiper-thumbs"
      >
      @for (img of articleImages; track img; let i = $index) {
        <swiper-slide
          ><img [src]="img.small" class="img clickable withOpacity" loading="lazy"
        /></swiper-slide>
      }
    </swiper-container>
  }
</div>
